"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUIZ_PLAYER_LIB_URL = process.env.REACT_APP_QUIZ_PLAYER_LIB_URL ||
    "https://d17pyvm023z8dn.cloudfront.net/js/digischool-quiz-player/prod/1.1.0/static/js/main.js";
exports.DEFAULT_QUIZ_TIMER_VALUE = process.env.REACT_APP_DEFAULT_QUIZ_TIMER_VALUE
    ? parseInt(process.env.REACT_APP_DEFAULT_QUIZ_TIMER_VALUE, 10)
    : 0;
//# sourceMappingURL=quizPlayer.config.js.map